import { v4 as uuidv4 } from "uuid";

export const data = [
  {
    id: uuidv4(),
    name: "Software Developement Engineer 1",
    description:
      "Function: Software Engineering → Backend Development, Java, Data Structures, Algorithms ",
    requiredTechStack: [],
    PostedOn: Date.now(),
    minimumYoeRequired: 2,
    sections: [
      {
        id: uuidv4(),
        title: "Applications",
        tasks: [
          {
            id: uuidv4(),
            firstName: "Rahul",
            lastName: "Bose",
            experience: 2,
            degree: "B.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
          {
            id: uuidv4(),
            firstName: "Priya",
            lastName: "Rai",
            experience: 3,
            degree: "M.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
        ],
      },
      {
        id: uuidv4(),
        title: "Reviewed",
        tasks: [
          {
            id: uuidv4(),
            firstName: "Madhur",
            lastName: "Joshi",
            experience: 2,
            degree: "B.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
          {
            id: uuidv4(),
            firstName: "Vijay",
            lastName: "Mohite",
            experience: 3,
            degree: "M.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
        ],
      },
      {
        id: uuidv4(),
        title: "Shortlisted",
        tasks: [
          {
            id: uuidv4(),
            firstName: "Raj",
            lastName: "Shekhar",
            experience: 2,
            degree: "B.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
          {
            id: uuidv4(),
            firstName: "Ganesh",
            lastName: "Acharya",
            experience: 3,
            degree: "M.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
        ],
      },
      {
        id: uuidv4(),
        title: "Rejected",
        tasks: [],
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Frontend Engineer",
    description:
      "Function: Software Engineering → Frontend Development, JavaScript, Next.js, React.js, Redux, TypeScript, Unit Testing",
    requiredTechStack: [],
    PostedOn: Date.now(),
    minimumYoeRequired: 2,
    sections: [
      {
        id: uuidv4(),
        title: "Applications",
        tasks: [
          {
            id: uuidv4(),
            firstName: "Rahul",
            lastName: "Pawar",
            experience: 2,
            degree: "B.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
          {
            id: uuidv4(),
            firstName: "Bhakti",
            lastName: "Sahu",
            experience: 3,
            degree: "M.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
        ],
      },
      {
        id: uuidv4(),
        title: "Reviewed",
        tasks: [
          {
            id: uuidv4(),
            firstName: "Mangesh",
            lastName: "Roy",
            experience: 2,
            degree: "B.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
          {
            id: uuidv4(),
            firstName: "Rajvir",
            lastName: "Gaur",
            experience: 3,
            degree: "M.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
        ],
      },
      {
        id: uuidv4(),
        title: "Shortlisted",
        tasks: [
          {
            id: uuidv4(),
            firstName: "Amol",
            lastName: "Jadhav",
            experience: 2,
            degree: "B.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
          {
            id: uuidv4(),
            firstName: "Ashish",
            lastName: "Sharma",
            experience: 3,
            degree: "M.Tech",
            subtasks: [],
            applicationDate: Date.now(),
            skills: [],
            noticePeriod: 15,
            resume: "resume.example.com",
            portfolio: "portfolio.example.com",
          },
        ],
      },
      {
        id: uuidv4(),
        title: "Rejected",
        tasks: [],
      },
    ],
  },
];
